import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { RoomPage } from "./room.page";

const routes: Routes = [
  {
    path: "",
    component: RoomPage,
  },
  {
    path: "room-details/:Id",
    loadChildren: () =>
      import("./room-details/room-details.module").then(
        (m) => m.RoomDetailsPageModule
      ),
    data: {
      breadcrumb: "SPACE.ROOM.DETAIL",
    },
  },
  {
    path: "add-room",
    loadChildren: () =>
      import("./room-details/room-details.module").then(
        (m) => m.RoomDetailsPageModule
      ),
    data: {
      breadcrumb: "SPACE.ROOM.DETAIL",
    },
  },
  {
    path: "add-reservation",
    loadChildren: () =>
      import(
        "./room-add-reservation-page/room-add-reservation-page.module"
      ).then((m) => m.RoomAddReservationPagePageModule),
    data: {
      breadcrumb: "SPACE.ADD_RESERVATION",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoomPageRoutingModule {}
